import {
  COMMANDE_CREER_SUCCES,
  COMMANDE_CREER_ECHEC,
  COMMANDE_CREER_RESET,
  COMMANDE_LISTE_CLI_SUCCES,
  COMMANDE_LISTE_CLI_ECHEC,
  COMMANDE_DETAILS_SUCCES,
  COMMANDE_DETAILS_ECHEC,
  COMMANDE_LISTE_CODE_SUCCES,
  COMMANDE_LISTE_CODE_ECHEC,
  COMMANDE_DETAILS_REQUETTE,
  COMMANDE_LISTE_REP_ECHEC,
  COMMANDE_LISTE_REP_SUCCES,
  COMMANDE_TOUS_SUCCES,
  COMMANDE_TOUS_ECHEC,
  COMMANDE_TOUS_REQUETTE,
  COMMANDE_LISTE_REP_REQUETTE,
  VENTE_RAPPORT_REQUETTE,
  VENTE_RAPPORT_SUCCES,
  VENTE_RAPPORT_ECHEC,
} from "../constantes/commandeConstantes";
export const creeCommandeReducer = (state = {}, action) => {
  switch (action.type) {
    case COMMANDE_CREER_SUCCES:
      return {
        loading: false,
        succes: true,
        commande: action.payload,
      };
    case COMMANDE_CREER_ECHEC:
      return {
        loading: false,
        erreur: action.payload,
      };
    case COMMANDE_CREER_RESET:
      return {
        loading: false,
        succes: false,
      };

    default:
      return state;
  }
};
export const commandeMonListeReducer = (state = { commandes: [] }, action) => {
  switch (action.type) {
    case COMMANDE_LISTE_CLI_SUCCES:
      return {
        commandes: action.payload,
        succes: true,
      };
    case COMMANDE_LISTE_CLI_ECHEC:
      return {
        loading: false,
        erreur: action.payload,
        succes: false,
      };

    default:
      return state;
  }
};

export const commandeDetailsReducer = (state = { commande: {} }, action) => {
  switch (action.type) {
    case COMMANDE_DETAILS_REQUETTE:
      return {
        loading: true,
      };
    case COMMANDE_DETAILS_SUCCES:
      return { loading: false, commande: action.payload };
    case COMMANDE_DETAILS_ECHEC:
      return {
        loading: false,
        erreur: action.payload,
      };

    default:
      return state;
  }
};

export const commandeListeCodeReducer = (state = { commandes: [] }, action) => {
  switch (action.type) {
    case COMMANDE_LISTE_CODE_SUCCES:
      return {
        commandes: action.payload,
        succes: true,
      };
    case COMMANDE_LISTE_CODE_ECHEC:
      return {
        loading: false,
        erreur: action.payload,
        succes: false,
      };

    default:
      return state;
  }
};
export const commandeListeRepReducer = (state = { commandes: [] }, action) => {
  switch (action.type) {
    case COMMANDE_LISTE_REP_REQUETTE:
      return {
        loading: true,
      };
    case COMMANDE_LISTE_REP_SUCCES:
      return {
        loading: false,
        commandes: action.payload,
        succes: true,
      };
    case COMMANDE_LISTE_REP_ECHEC:
      return {
        loading: false,
        erreur: action.payload,
        succes: false,
      };

    default:
      return state;
  }
};
export const commandeTousReducer = (state = { commandes: [] }, action) => {
  switch (action.type) {
    case COMMANDE_TOUS_REQUETTE:
      return {
        loading: true,
      };
    case COMMANDE_TOUS_SUCCES:
      return {
        commandes: action.payload,
        succes: true,
        loading: false,
      };
    case COMMANDE_TOUS_ECHEC:
      return {
        loading: false,
        erreur: action.payload,
        succes: false,
      };

    default:
      return state;
  }
};

export const rapportVenteReducer = (state = { articlesVnt: [] }, action) => {
  switch (action.type) {
    case VENTE_RAPPORT_REQUETTE:
      return {
        loading: true,
      };
    case VENTE_RAPPORT_SUCCES:
      return {
        articlesVnt: action.payload,
        loading: false,
      };
    case VENTE_RAPPORT_ECHEC:
      return {
        loading: false,
        erreur: action.payload,
      };

    default:
      return state;
  }
};
